import axios from "axios";
import { getDefaultConfigHeader } from "../../Utils/headerDefaultConfigPetition";

const url = process.env.REACT_APP_API_BACKEND + "/permission";

export const getPermissions = () => axios.get(url, getDefaultConfigHeader());

export const addPermission = (permission: { name: string }) =>
  axios.post(url, permission, getDefaultConfigHeader());

export const updatePermission = (id: number, permission: { name: string }) =>
  axios.put(`${url}/${id}`, permission, getDefaultConfigHeader());

// Desasigna el permiso de todos los roles
export const deletePermission = (id: number) => axios.delete(`${url}/${id}`, getDefaultConfigHeader());
